import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { useNavigate } from "react-router-dom";
import { Flame } from "lucide-react";
import { whenFree } from "@/lib/popupQueue";
import { useQuest, useLeft } from "@/lib/quest";
import { QuestGoals } from "@/components/quest/QuestGoals";

const KEY = "itz_quest_popup";

export function QuestPopup() {
  const [q] = useQuest(60000);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const at = q?.status === "running" && !q.excluded && !q.done ? q.popup_at : null;
  useEffect(() => {
    if (!at || localStorage.getItem(KEY) === at) return;
    whenFree(`quest-${at}`, () => { localStorage.setItem(KEY, at); setOpen(true); });
  }, [at]);
  const { text } = useLeft(q?.end);
  if (!open || !q) return null;
  const close = (go) => { setOpen(false); if (go) navigate("/community-aufgabe"); };
  return createPortal(
    <div className="fixed inset-0 z-[85] flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm wheel-fade" data-testid="quest-popup">
      <div className="quest-glow sky-celebrate w-full max-w-md rounded-[2rem] p-6 text-white space-y-4 relative overflow-hidden">
        <span className="contest-shine" />
        <p className="relative text-xs font-extrabold uppercase tracking-[0.25em] flex items-center gap-1.5"><Flame className="w-4 h-4" /> Community-Aufgabe · Zwischenstand</p>
        <p className="relative font-display text-2xl font-extrabold">Noch <span className="tabular-nums" data-testid="quest-popup-timer">{text}</span> – schaffen wir das?</p>
        <div className="relative"><QuestGoals goals={q.goals} /></div>
        <p className="relative text-sm text-red-50">Schaffen wir {q.goals.length === 1 ? "das Ziel" : `alle ${q.goals.length} Ziele`}, bekommt jeder Mitmacher {q.stake} Punkte. Sonst verliert jeder Mitmacher {q.stake} Punkte!</p>
        <button onClick={() => close(true)} data-testid="quest-popup-go" className="relative w-full h-12 rounded-full bg-white text-[#b0002a] font-extrabold">Jetzt mithelfen</button>
        <button onClick={() => close(false)} data-testid="quest-popup-close" className="relative w-full text-sm font-semibold text-red-100">Später</button>
      </div>
    </div>,
    document.body
  );
}
